module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "meenit-answer",
    class: {
      'is-favorite': _vm.item.favorite
    }
  }, [_c('p', {
    staticClass: "meenit-answer-date"
  }, [_vm._v(_vm._s(_vm.item.formatted_created_at))]), _vm._v(" "), (_vm.item.voice_recording_attached) ? [_c('div', {
    staticClass: "player"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "controls"
  }, [(_vm.playState === 'pause') ? [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onPlay($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "alt": "Play",
      "src": "/images/img-apple-64/25b6-fe0f.png"
    }
  })])] : [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onPause($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "alt": "Pause",
      "src": "/images/img-apple-64/23f8-fe0f.png"
    }
  })])]], 2), _vm._v(" "), _c('div', {
    staticClass: "recording"
  }, [_c('div', {
    ref: "wave",
    staticClass: "wave"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sub"
  }, [_c('div', {
    staticClass: "controls"
  }), _vm._v(" "), _c('div', {
    staticClass: "duration"
  }, [_vm._v("\n          " + _vm._s(_vm.playState === "pause" ? _vm.duration : _vm.playtime) + "\n        ")])])])] : [_c('span', {
    staticStyle: {
      "white-space": "pre-wrap"
    }
  }, [_vm._v(_vm._s(_vm.item.content))])], _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "field emoji emoji-link waste",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.$emit('onDelete', {
          id: _vm.item.id,
          url: _vm.item.delete_endpoint
        })
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "deletelink"
    }
  }, [_vm._v(_vm._s(_vm.texts.delete))]), _vm._v(" "), _c('span', {
    staticClass: "tooltip"
  }, [_vm._v(_vm._s(_vm.texts.delete))])]), _vm._v(" "), _c('div', {
    staticClass: "field emoji emoji-link star",
    class: {
      'is-favorite': _vm.item.favorite
    }
  }, [_c('a', {
    attrs: {
      "href": "favoritelink"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.$emit('onFavorite', {
          id: _vm.item.id,
          url: _vm.item.favorite_endpoint
        })
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.toggleFavoriteText) + "\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "tooltip"
  }, [_vm._v(_vm._s(_vm.toggleFavoriteText))])])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27293f4e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/packs/questions/answers/item.vue
// module id = 202
// module chunks = 0 1 4